export const Chip = ({ active, onClick, children, testId, color = "orange" }) => (
  <button type="button" data-testid={testId} onClick={onClick}
    className={`px-3.5 py-1.5 rounded-full text-sm border transition-colors duration-200 ${
      active
        ? color === "violet" ? "bg-[var(--c-violet)]/20 border-[var(--c-violet)] text-white" : "bg-[var(--c-orange)] border-[var(--c-orange)] text-white"
        : "border-[var(--c-line)] text-zinc-300 hover:border-zinc-500 hover:text-white"}`}>
    {children}
  </button>
);

export const ChipGroup = ({ label, items, value, onChange, prefix, color, multi }) => (
  <div>
    <p className="text-[11px] uppercase tracking-[0.14em] text-zinc-500 font-semibold mb-2.5">{label}</p>
    <div className="flex flex-wrap gap-2">
      {items.map((it) => {
        const active = multi ? value.includes(it.id) : value === it.id;
        const toggle = () => multi ? onChange(active ? value.filter((v) => v !== it.id) : [...value, it.id]) : onChange(active ? "" : it.id);
        return <Chip key={it.id} testId={`${prefix}-${it.id}`} active={active} onClick={toggle} color={color}>{it.name}</Chip>;
      })}
    </div>
  </div>
);

export const Field = ({ label, children, right }) => (
  <div>
    <div className="flex items-center justify-between mb-2.5">
      <p className="text-[11px] uppercase tracking-[0.14em] text-zinc-500 font-semibold">{label}</p>
      {right}
    </div>
    {children}
  </div>
);

export const inputCls = "w-full bg-[var(--c-surface)] border border-[var(--c-line)] rounded-xl px-4 py-3 text-sm placeholder:text-zinc-600 focus:outline-none focus:border-[var(--c-orange)] transition-colors duration-200";
